import openWindow from '@/script/openWindow.mjs'

export const canPreviewWf = (map, wf) => {
    const {demoType, pkid: wfId, bfId} = wf.data

    if (! wfId) {
        return false
    }

    // if ('IMG' === demoType) {
    //     return false;
    //     // if (! bfId) {
    //     //     return false
    //     // }

    //     // return [...map.children(wf)].some(
    //     //     n => n.data.fileId
    //     // )
    // }

    return true
}

export const previewWf = (map, wf, target) => {
    const {demoType, pkid: wfId, bfId} = wf.data
    /* const params = new URLSearchParams(location.search.split("?")[1]);
    let otherProps = {}; */
    /* if(location.pathname == '/FlowPreview' && params.get('prjId')) {
        otherProps.prjId = params.get('prjId');
        otherProps.sVer = params.get('sVer') || 1;
    } */

    ;({
        DEMO: () => {
            openWindow('/FlowPreview', { wfId }, target)
        },

        IMG: () => {
            openWindow('/FlowPreview', { wfId }, target)
        },
    })[demoType]()
}
